<template>
  <div class="bg-white">
    <div class="relative z-index1 h-full w-full">
      <div class="">
        <ConnectCover />
        <ContactForm class="pb-5" />
        <ContactGrid />
      </div>
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import ConnectCover from "./components/ConnectCover.vue";
import ContactForm from "./components/ContactForm.vue";
import ContactGrid from "./components/ContactGrid.vue";
import Footer from "../../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
export default {
  components: {
    ConnectCover,
    ContactForm,
    ContactGrid,

    Footer,
    DownloadApp,
  },
};
</script>

<style></style>
